import { Links } from '_types/public-api';

export const categoryFiltered = (links: Links | null | undefined, category: string) =>
  links?.data.filter((link) => link?.attributes?.category === category);
